import { ref, isRef, toValue, type Ref } from 'vue';
import axios from 'axios';
import { configHelper } from '@ilteducation/config';
import type { CloseEndedQuestion, Exercise } from '@ilteducation/exercise-service-types';

export function useVideoQuestions(resourceId: Ref<string> | string): {
  questions: Ref<CloseEndedQuestion[]>;
  loading: Ref<boolean>;
  error: Ref<unknown>;
  fetch: () => Promise<void>;
} {
  const questions = ref<CloseEndedQuestion[]>([]);
  const loading = ref(false);
  const error = ref<unknown>(null);

  const fetch = async () => {
    const exerciseApi = configHelper.getApiUrl('exercises');
    const id = isRef(resourceId) ? toValue(resourceId) : resourceId;

    loading.value = true;
    error.value = null;

    try {
      const response = await axios.get<{ data: Exercise[] }>(`${exerciseApi}/?resourceId=${id}`);
      const exercises = response.data.data ?? [];

      questions.value = exercises
        .filter((exercise) => exercise.type === 'quiz')
        .flatMap((exercise) =>
          exercise.content.filter((item): item is CloseEndedQuestion => item.type === 'closed-question'),
        );
    } catch (err) {
      error.value = err;
      questions.value = [];
    } finally {
      loading.value = false;
    }
  };

  return {
    questions,
    loading,
    error,
    fetch,
  };
}
